import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const xcoverAPI = createApi({
  reducerPath: 'xcoverApi',
  baseQuery: fetchBaseQuery({
    prepareHeaders: async (headers) => {
      const auth = headers.get('auth');
      headers.delete('auth');
      if (auth === 'false') {
        return headers;
      }
      const token = `Bearer dummy token`;
      headers.set('Authorization', token);
      const mode = import.meta.env.MODE;
      if (mode === 'development' || mode === 'preview') {
        const tenant = localStorage.getItem('tenant');
        if (tenant) {
          headers.set('x-tenant', tenant);
        }
      }

      return headers;
    },
  }),
  endpoints: () => ({}),
  tagTypes: ['Bookings', 'Booking', 'COI'],
});
